function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "rgb(15.294118%,51.372549%,31.764706%)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    d: "M 7.382812 29.179688 C 7.597656 29.292969 7.839844 29.34375 8.082031 29.328125 C 8.324219 29.316406 8.558594 29.234375 8.757812 29.097656 L 26.09375 17.097656 C 26.269531 16.972656 26.414062 16.808594 26.515625 16.617188 C 26.613281 16.425781 26.664062 16.214844 26.664062 16 C 26.664062 15.785156 26.613281 15.574219 26.515625 15.382812 C 26.414062 15.191406 26.269531 15.027344 26.09375 14.902344 L 8.757812 2.902344 C 8.558594 2.765625 8.324219 2.683594 8.082031 2.667969 C 7.839844 2.65625 7.597656 2.707031 7.382812 2.820312 C 7.164062 2.933594 6.984375 3.101562 6.859375 3.308594 C 6.734375 3.519531 6.667969 3.757812 6.667969 4 L 6.667969 28 C 6.667969 28.242188 6.734375 28.480469 6.859375 28.691406 C 6.984375 28.898438 7.164062 29.070312 7.382812 29.179688 Z M 7.382812 29.179688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.fd70bed0.svg";
export { ForwardRef as ReactComponent };